var ACG_CONSTANT = ACG_CONSTANT || {};

ACG_CONSTANT.BREAKPOINT_SCREEN_SM_MIN = 768; // scss: $screen-sm-min
ACG_CONSTANT.BREAKPOINT_SCREEN_MD_MIN = 1000; // scss: $screen-md-min
ACG_CONSTANT.BREAKPOINT_SCREEN_LG_MIN = 1200; // scss: $screen-lg-min

ACG_CONSTANT.HEADER_DESKTOP_BREAKPOINT = 1000; // scss: $header-desktop-breakpoint
